import { gql, TypedDocumentNode } from "@apollo/client";

import {
  ApiKey,
  Mutation,
  MutationAccountSetPersonalApiKeysEnabledArgs,
  MutationPersonalApiKeyDisableArgs,
  Query,
} from "types/generated";

type GetPersonalApiKeysEnabledData = Pick<Query, "personalApiKeysEnabled">;

export const GET_PERSONAL_API_KEYS_ENABLED: TypedDocumentNode<GetPersonalApiKeysEnabledData> = gql`
  query GetPersonalApiKeysEnabled {
    personalApiKeysEnabled
  }
`;

type GetPersonalApiKeysCountData = Pick<Query, "personalApiKeysCount">;

export const GET_PERSONAL_API_KEYS_COUNT: TypedDocumentNode<GetPersonalApiKeysCountData> = gql`
  query GetPersonalApiKeysCount {
    personalApiKeysCount
  }
`;

type SetPersonalApiKeysEnabledData = Pick<Mutation, "accountSetPersonalApiKeysEnabled">;

export const SET_PERSONAL_API_KEYS_ENABLED: TypedDocumentNode<
  SetPersonalApiKeysEnabledData,
  MutationAccountSetPersonalApiKeysEnabledArgs
> = gql`
  mutation AccountSetPersonalApiKeysEnabled($enabled: Boolean!, $disableExistingKeys: Boolean) {
    accountSetPersonalApiKeysEnabled(enabled: $enabled, disableExistingKeys: $disableExistingKeys)
  }
`;

type RequestPersonalApiKeysEnablingData = Pick<Mutation, "accountRequestPersonalApiKeysEnabling">;

export const REQUEST_PERSONAL_API_KEYS_ENABLING: TypedDocumentNode<RequestPersonalApiKeysEnablingData> = gql`
  mutation AccountRequestPersonalApiKeysEnabling {
    accountRequestPersonalApiKeysEnabling
  }
`;

type RevokePersonalApiKeyData = {
  personalApiKeyDisable: Pick<ApiKey, "id" | "disabled" | "disabledAt" | "disabledReason">;
};

export const REVOKE_PERSONAL_API_KEY: TypedDocumentNode<
  RevokePersonalApiKeyData,
  MutationPersonalApiKeyDisableArgs
> = gql`
  mutation RevokePersonalApiKey($id: ID!) {
    personalApiKeyDisable(id: $id) {
      id
      disabled
      disabledAt
      disabledReason
    }
  }
`;
